import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import tw from "tailwind-styled-components";
import Images from "../../Images";

const DropZone = ({ setFieldValue, componentFor, setUploadFile }) => {
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (componentFor === "profile") {
            setFieldValue("media", file);
        } else if (componentFor === "expense") {
            setFieldValue("file", file);
        } else if (componentFor === "doc-valut") {
            setFieldValue("file", file);
        } else if (componentFor === "food-menu") {
            setFieldValue("file", file);
        }
        else if (componentFor === "admin") {
            setUploadFile(file);
        }
    }, [file]);

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const tempFile = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );
            setFile(tempFile);
        }
    }, []);

    const accept =
        componentFor === "profile"
            ? "image/png,image/jpg,image/jpeg,image/webp"
            : componentFor === "expense"
                ? ".png,.jpg,.jpeg,.webp,.pdf"
                : componentFor === "doc-valut"
                    ? ".png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.xls,.xlsx,.xlsm,.xltx,.xlsb"
                    : componentFor === "admin"
                        ? ".xlsx,.xlsm,.xltx,.xlsb"
                        : componentFor === "food-menu"
                            ? ".xls,.xlsx,.xlsm,.xltx,.xlsb"
                            : ".xlsx,.xlsm,.xltx,.xlsb";

    const minSize = 0;
    const maxSize = 26214400; // 25 MB
    const maxFiles = 1;

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept,
        minSize,
        maxSize,
        maxFiles,
    });

    const removePreviewImage = () => setFile(null);

    return (
        <>
            {!file && (
                <Uploader
                    getRootProps={getRootProps}
                    getInputProps={getInputProps}
                    isDragActive={isDragActive}
                    componentFor={componentFor}
                />
            )}

            {componentFor === "profile" && file && (
                <SingleFile file={file} removePreviewImage={removePreviewImage} />
            )}

            {componentFor !== "profile" && file && (
                <FileName>
                    {file[0].name}
                    <PreviewFigure onClick={removePreviewImage} $admin={true}>
                        <img src={Images.Cross} className="w-2" />
                    </PreviewFigure>
                </FileName>
            )}
        </>
    );
};

const Uploader = ({ getRootProps, getInputProps, isDragActive, componentFor }) => {
    const getInstruction = () => {
        switch (componentFor) {
            case "profile":
                return "Click or Drag Images To Upload";
            case "expense":
                return "Click or Drag Any Images & Pdf To Upload";
            case "doc-valut":
                return "Click or Drag Any Images, Docs, XL, & Pdf To Upload";
            case "admin":
                return "Click or Drag Excel File To Upload";
            default:
                return "Click or Drag File To Upload";
        }
    };

    const getSupportedFormats = () => {
        const formats = {
            profile: "JPG, PNG, WEBP",
            expense: "JPG, PNG, WEBP, PDF",
            "doc-valut": "JPG, PNG, PDF, DOCX, XLSX",
            admin: "XLSX, XLSM, XLTX, XLSB",
            "food-menu": "XLS, XLSX, XLSM, XLTX, XLSB",
        };

        return (
            <>
                {formats[componentFor] && (
                    <p>{formats[componentFor]}</p>
                )}
                <p className="text-xs text-gray-500 mt-1">
                    Maximum upload size: 25 MB
                </p>
            </>
        );
    };

    return (
        <div
            {...getRootProps()}
            className="w-full h-full bg-gray-50 rounded-md border-2 border-gray-200"
        >
            <input {...getInputProps()} />
            <div
                className={`w-full h-full grid place-content-center p-3 ${isDragActive ? "bg-gray-300" : ""
                    }`}
            >
                <Label htmlFor="file">
                    <TextWrapper>
                        <img src={Images.Upload} alt="upload-icon" className="w-5" />
                        <p>{isDragActive ? "Drop it like it's hot" : getInstruction()}</p>
                        {getSupportedFormats()}
                    </TextWrapper>
                </Label>
            </div>
        </div>
    );
};

const SingleFile = ({ file, removePreviewImage }) => (
    <div className="w-28 h-28 relative mt-2">
        <PreviewFigure onClick={removePreviewImage}>
            <img src={Images.Cross} className="w-2" />
        </PreviewFigure>

        <img
            src={file[0].preview}
            className="object-contain w-full h-full"
            alt="image"
        />
    </div>
);

const TextWrapper = tw.div`
${(p) => (p.$isDragActive ? "bg-gray-400" : " bg-gray-100")}
 upload-fonts w-full rounded-lg text-gray-600 flex flex-col items-center py-4 px-3 gap-0 mt-1 cursor-pointer md:text-xs md:gap-2 md:px-8 md:py-5
`;

const Label = tw.label`
text-sm text-gray-600`;

const PreviewFigure = tw.div`
${(p) => (p.$admin ? "top-2.5 right-2" : "-top-1 -right-1")}
w-5 h-5 rounded-full grid place-items-center cursor-pointer absolute bg-black`;

const FileName = tw.p`relative font-medium p-3 w-full bg-gray-100 rounded-md text-gray-500 text-sm`;

export default DropZone;
